import React, { Component } from 'react';
import gitHubLogo from '../assets/GitHub-Mark-64px.png';
import connectFourPic from '../assets/boardpic-150x150.png';
import pantryBuddyPic from '../assets/PantryBuddySmall.png';
import zombieDefenseLogo from '../assets/ZombieDefenseLogo.png';
import trinityDesktopShot from '../assets/TrinitySmallWelcome.png';
class Projects extends Component {
    render() {
        return (
          <article
            id="projects"
            className="content-article active-article add-padding animated fadeIn"
          >
            <section className="hero is-primary">
              <div className="hero-body">
                <h1 className="title flex-center-content">Projects</h1>
              </div>
            </section>
            <div className="flex">
              <a
                href="https://github.com/WilliamJohnsonJr"
                className="flex align-center"
              >
                <figure className="image is-64x64 pointer add-padding">
                  <img src={gitHubLogo} alt="Will's Personal GitHub"></img>
                </figure>
                WILL’S PERSONAL GITHUB
              </a>
              <a
                href="https://github.com/wjohnson-truework"
                className="flex align-center"
              >
                <figure className="image is-64x64 pointer add-padding">
                  <img src={gitHubLogo} alt="Will's Truework GitHub"></img>
                </figure>
                WILL'S TRUEWORK GITHUB
              </a>
            </div>
            <div className="container">
              <h2>Why aren't there more GitHub links for my work?</h2>
              <ol className="px-5">
                <li>
                  My{" "}
                  <a href="https://soltech.net" target="_blank" rel="noreferrer">
                    SOLTECH
                  </a>{" "}
                  GitHub was scuttled when I left{" "}
                  <a href="https://soltech.net" target="_blank" rel="noreferrer">
                    SOLTECH
                  </a>{" "}
                  to join{" "}
                  <a href="https://adp.com" target="_blank" rel="noreferrer">
                    ADP
                  </a>
                  .
                </li>
                <li>
                  <a href="https://adp.com" target="_blank" rel="noreferrer">
                    ADP
                  </a>{" "}
                  did not use GitHub. So I don't have any achievement badges to
                  show for my three years there, but I worked with some really
                  amazing engineers.
                </li>
                <li>
                  All of that work was in private repositories anyway, so you
                  couldn't see it if you wanted to.
                </li>
                <li>
                  Want more details about what I've done on the job? View{" "}
                  <a
                    href="https://www.linkedin.com/in/williamtjohnsonjr"
                    target="_blank"
                    rel="noreferrer"
                  >
                    my LinkedIn profile
                  </a>
                  .
                </li>
              </ol>
              <h2 className="add-top-30">SOLTECH PRESENTATIONS</h2>
              <h3 className="add-top-30">
                Fun with Forge: Examples of Authentication and AES-256
                encryption in JavaScript
              </h3>
              <p>
                Watch me talk about end-to-end encryption with a live example of
                Fun with Forge during this talk at SOLTECH, Inc.:
              </p>
              <div>
                <iframe
                  title="End-to-End Encryption in 2017"
                  width="300"
                  height="200"
                  src="https://www.youtube.com/embed/3tx2AxbKYyc"
                  frameBorder="0"
                  allow="encrypted-media"
                  allowFullScreen
                ></iframe>
              </div>
              <p>
                <em>
                  Note: this one is for fairly technically-oriented people. It
                  has live examples of SHA-256, HMAC example of
                  authenticate-then-encrypt, etc.
                </em>
              </p>

              <h2 className="add-top-30">PROJECTS FOR CLIENTS</h2>
              <div className="add-top-30" style={{ width: "300px" }}>
                <a href="https://www.trinityepc.com/" target="_blank" rel="noreferrer">
                  <img src={trinityDesktopShot} alt="Trinity EPC" />
                </a>
              </div>
              <h3>Trinity EPC</h3>
              <p>
                A Squarespace website customized and built from a base template
                according to{" "}
                <a href="https://www.trinityepc.com" target="_blank" rel="noreferrer">
                  Trinity EPC's
                </a>{" "}
                requirements. I handled all aspects of the project, from initial
                design and platform selection with the client through
                deployment, domain setup and registration, etc. The current
                website has gone through an additional transformation since I
                completed this project.
              </p>
              <p className="add-top-10">
                <span className="bold">Tools used:</span> Squarespace local
                development tools, customized CSS, customized JavaScript and
                routing logic, Adobe Photoshop (artboards/wireframes/mockups),
                Adobe Illustrator.
              </p>

              <h2 className="add-top-30">PERSONAL PROJECTS</h2>
              <div className="add-top-30">
                <a href="https://github.com/WilliamJohnsonJr/pantry-buddy">
                  <img
                    src={pantryBuddyPic}
                    alt="Pantry Buddy application screen shot."
                  />
                </a>
              </div>
              <h3>
                Pantry Buddy (NgRx, Angular Material, Redux DevTools)
                (In-Progress) |{" "}
                <a href="https://github.com/WilliamJohnsonJr/pantry-buddy">
                  Code Repo
                </a>
              </h3>
              <p>
                An online grocery list and meal planning app built with NgRx,
                Redux architecture, normalized data, and state sliced by feature
                with OnPush Change Detection and performance optimizations
                throughout.
              </p>
              <p className="add-top-10">
                <span className="bold">Tools used:</span> NgRx, Angular
                Material, Redux DevTools, dynamic Reactive Forms in Angular 6,
                forthcoming modules with NgRx Data, forthcoming unit test suite
                with Karma and Jasmine.
              </p>

              <div className="add-top-30">
                <a href="https://williamjohnsonjr-connectfour.surge.sh/">
                  <img src={connectFourPic} alt="ES6 Connect Four Logo" />
                </a>
              </div>
              <h3>
                ES6 Connect Four (ES6 modules and imports){" "}
                <a href="https://williamjohnsonjr-connectfour.surge.sh/">
                  Live App
                </a>{" "}
                |{" "}
                <a href="https://github.com/WilliamJohnsonJr/es6-connect4">
                  Code Repo
                </a>
              </h3>
              <p>
                A Connect Four game built using ES6 JavaScript! One-player game
                with the computer as black and the player as red. The computer
                opponent AI was completely designed by me.
              </p>
              <p className="italic">Note: This site is fully responsive.</p>
              <p className="add-top-10">
                <span className="bold">Tools used:</span> ES6 JavaScript modules
                and code, JavaScript, HTML, CSS, jQuery, Lodash (JS Library),
                Responsive Design, Basic Artificial Intelligence.
              </p>

              <div className="add-top-30">
                <a href="https://williamjohnsonjr-zombiedefense.surge.sh/">
                  <img src={zombieDefenseLogo} alt="Zombie Defense Logo" />
                </a>
              </div>
              <h3>
                ZOMBIE DEFENSE (ES6 modules and imports){" "}
                <a href="https://williamjohnsonjr-zombiedefense.surge.sh/">
                  Live App
                </a>{" "}
                |{" "}
                <a href="https://github.com/WilliamJohnsonJr/zombiedefense">
                  Code Repo
                </a>
              </h3>
              <p>
                A Zombie Defense game. Can you make it to Level 100? Built as a
                weekend project. Zombie graphics by irmirx. License: CC-BY-3.0.
                No changes were made to the original image. Image available at:{" "}
                <a href="http://opengameart.org/content/zombie-animations">
                  http://opengameart.org/content/zombie-animations
                </a>
              </p>
              <p className="italic">
                Note: This site should be viewed on a desktop in Google Chrome
                or Firefox Quantum.
              </p>
              <p className="add-top-10">
                <span className="bold">Tools used:</span> JavaScript, jQuery,
                HTML, Sass/SCSS, Gulp, ES6 imports, and class-based syntax in
                JavaScript
              </p>

              <h2 className="add-top-30">OPEN SOURCE PROJECTS</h2>
              <h3 className="add-top-30">
                Angular Chart{" "}
                <a href="https://jtblin.github.io/angular-chart.js/">
                  Documentation
                </a>{" "}
                |{" "}
                <a href="https://github.com/jtblin/angular-chart.js">
                  Code Repo (Open Source library)
                </a>
              </h3>
              <p>
                JavaScript library that enables reactive, responsive, beautiful
                charts for AngularJS based on Chart.js . I contribute to the
                Angular Chart open source project on GitHub, and I am listed on
                the contributors list in the Graphs section of the repo.
              </p>
            </div>
          </article>
        );
    }
}

export default Projects;